import { useTranslation } from "react-i18next";
import type { CheckReport } from "../../../api/content/reviewDecoders";
import Chip from "../../../ui/feedback/Chip";
import { CHECK_STATUS_TONE } from "./checkStatusTone";

/**
 * A check report's result in one chip, for a place that folds its results away (usability round 5, P2-3): its status
 * in the review's words and tone, and how many findings its checks have, if any; a passing check may hold warnings.
 */
export default function CheckReportChip({ report }: { report: CheckReport }) {
  const { t } = useTranslation();
  const findings = [...report.results, ...(report.processResults ?? [])].reduce((total, result) => total + result.findingCount, 0);
  const status = t(`reviews.checks.status.${report.status}`);
  return (
    <Chip tone={CHECK_STATUS_TONE[report.status]} size="compact">
      {findings > 0 ? `${status} · ${t("reviews.checks.findings", { count: findings })}` : status}
    </Chip>
  );
}
